import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DesignAngularKitModule, ItModalComponent, ItNotificationService, NotificationPosition } from 'design-angular-kit';
import { DischargeInfo, DischargeInfoDto, RequestDto } from '../../../../models/request.dto';
import { AuthService } from '../../../../services/auth.service';
import { RequestSummaryComponent } from '../../../../components/request-summary/request-summary.component';
import { FormsModule } from '@angular/forms';
import { EnrollementData } from '../../../../models/enrollement-data.model';
import { EnrollementService } from '../../../../services/enrollement.service';
import { InsertDischargeDateModalComponent } from '../insert-discharge-date-modal/insert-discharge-date-modal.component';
import { RequestService } from '../../../../services/request.service';
import { NoteService } from '../../../../services/note.service';
import { format } from 'date-fns';

@Component({
  selector: 'app-enrollement-action',
  standalone: true,
  imports: [CommonModule,
    DesignAngularKitModule,
    FormsModule,
    InsertDischargeDateModalComponent,
    RequestSummaryComponent
  ],
  templateUrl: './enrollement-action.component.html',
  styleUrl: './enrollement-action.component.scss'
})
export class EnrollementActionComponent {

  @Input() request!: RequestDto;
  @Output() refreshRequest = new EventEmitter<any>();
  @Input() requestDates: DischargeInfo[] = [];
  @Input() enrollementData: EnrollementData | undefined;
  @ViewChild('insertDischargeDateModal') insertDischargeDateModal!: ItModalComponent;

  constructor(
    private enrollementService: EnrollementService,
    public authService: AuthService,
    private requestService: RequestService,
    private noteService: NoteService
  ) { }

  cancel() {
    this.enrollementService.revoke(this.request.uuid).subscribe(result => {
      this.refreshRequest.emit();
    }, error => {
    }
    );
  }

  send() {
    this.enrollementService.send(this.request.id).subscribe(result => {
      this.refreshRequest.emit();
    }, error => {
      this.refreshRequest.emit();
    }
    );
  }

  isDatePresent(dateType: string): boolean {
    return this.requestDates.find(d => d.dateType.code == dateType) ? true : false;
  }

  cancelledCompleteRequest() {
    this.insertDischargeDateModal.toggle();
  }

  insertDischargeDate(event: { dischargeDate: Date|null; dischargeTime: string|null; note: string|null; }) {
    let dischargeDateTime = format(event.dischargeDate!,'yyyy-MM-dd').toString()+'T'+ event.dischargeTime+':00';
    let payload: DischargeInfoDto = {
      date: dischargeDateTime,
      operatorCode: this.authService.userInfo.username,
      transitionId: this.request.id,
      typeId: 2
    };
    if (this.requestDates && this.requestDates.find(d => d.dateType?.code == 'DDE')) {
      payload.id = this.requestDates.find(d => d.dateType?.code == 'DDE')?.id;
      this.requestService
        .updateDischargeInfo(payload)
        .subscribe(() => {
          this.insertNoteForDischargeDate(dischargeDateTime,event.note);
        });
    } else {
      this.requestService
        .createDischargeInfo(payload)
        .subscribe(() => {
          this.insertNoteForDischargeDate(dischargeDateTime,event.note);
        });
    }
    this.insertDischargeDateModal.toggle();
  }

    insertNoteForDischargeDate(dischargeDate: string, note: string | null ) {
      const request = {
        transitionId: this.request.id,
        typeId: '5',
        text: 'Aggiornamento data effettiva dimissione a '+ dischargeDate + (note ? ' per: ' + note : ''),
        insertUserCode: this.authService.userInfo.username,
        title: 'Data effettiva dimissione'
      }
      this.noteService.insertNote(request).subscribe(result => {
        this.refreshRequest.emit();
      });
    }
}
